import { useState } from 'react';
import ApiService from '@api/index';
import { MutationDataHookResult, PageConfig } from '@/types';
import { METHODS } from '@constants/api';
import { VITE_NODE_ENV } from '@/utils/getEnv';

interface ReportResponse {
  results: any;
  scenario: any;
}

const useGenerateReport = (): MutationDataHookResult<ReportResponse> => {
  const [isFetched, setIsFetched] = useState<boolean>(false);
  const [data, setData] = useState<ReportResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [animationComplete, setAnimationComplete] = useState<boolean>(false);

  const generateReport = async (uuid: string) => {
    setLoading(true);
    setIsFetched(true);
    setError(null);
    setAnimationComplete(false);

    try {
      const user = VITE_NODE_ENV['VITE_USER_API_PARAMS'];
      const previlege = VITE_NODE_ENV['VITE_USER_PREVILEGE'];
      const endpoint = `/gridty_calculations/?uuid=${uuid}&user=${user}&access_previlege=${previlege}`;
      // const endpoint = `/gridty_calculations/?uuid=${uuid}&user=${user}&session_id=${sessionId}`;
      const response = await ApiService.request<ReportResponse>({ endpoint, method: METHODS.GET });
      setData(response);

      setAnimationComplete(true);
    } catch (error) {
      setError((error as Error).message);
      setAnimationComplete(true);
    } finally {
      setLoading(false);
    }
  };

  return [generateReport, { data: data as ReportResponse, loading, error, isFetched, animationComplete }];
};

export default useGenerateReport;
